// extracted by mini-css-extract-plugin
module.exports = {"text_input":"styles_text_input__m42qP","error_message":"styles_error_message__3Dpkl","brand_v2":"styles_brand_v2__cw-F4"};